'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { PureComponent } from 'react';
import { connect } from 'react-redux';
import { EntityTypes } from 'AdsUI/lib/Constants';
import { getToggledEntityStatus } from 'AdsUI/lib/Utils';
import { usageTracker } from 'AdsUI/lib/usageTracker';
import EntityStatusToggleButton from 'AdsUI/components/EntityStatusToggleButton';
import { updateReportingEntityStatus } from 'AdsUI/actions/CampaignReportingActions';
import StopPropagationWrapper from 'AdsUI/components/StopPropagationWrapper';
import { hasAccessToRoiReporting, hasWriteScope } from 'AdsUI/selectors/AuthSelectors';
import { getErrorsByAdAccount } from 'AdsUI/selectors/AccountsSelectors';

class CampaignStatusToggleButtonContainer extends PureComponent {
  onToggleCampaignStatus() {
    const {
      entity,
      entity: {
        network,
        status
      },
      adAccount
    } = this.props;
    usageTracker.track('modifyCampaign', {
      action: 'Toggled entity status',
      entityType: EntityTypes.CAMPAIGN,
      network
    });
    this.props.updateReportingEntityStatus(network, adAccount, entity, EntityTypes.CAMPAIGN, false, null, getToggledEntityStatus(status, network));
  }

  render() {
    const {
      hasRoiReportingScope,
      writeScope,
      entity,
      entityType,
      size,
      errorsByAdAccount,
      adAccount
    } = this.props;
    return /*#__PURE__*/_jsx(StopPropagationWrapper, {
      className: "m-x-3 campaign-status-toggle",
      children: /*#__PURE__*/_jsx(EntityStatusToggleButton, {
        campaignEntity: entity,
        entity: entity,
        entityType: entityType,
        hasRoiReportingScope: hasRoiReportingScope,
        hasWriteScope: writeScope,
        adAccount: adAccount,
        errorsByAdAccount: errorsByAdAccount,
        onChange: this.onToggleCampaignStatus.bind(this),
        size: size
      })
    });
  }

}

export default connect(state => ({
  hasRoiReportingScope: hasAccessToRoiReporting(state),
  errorsByAdAccount: getErrorsByAdAccount(state),
  writeScope: hasWriteScope(state)
}), {
  updateReportingEntityStatus
})(CampaignStatusToggleButtonContainer);